const OperationsFromDocument = require('./operationsFromDocument');
const OperationsToDocument = require('./operationsToDocument');

const operationsFromDocumentInst = new OperationsFromDocument();
const operationsToDocumentInst = new OperationsToDocument();

module.exports = {
  operationsFromDocument: (document, options = {}) => operationsFromDocumentInst.convert(document, options),
  operationsToDocument: (operations, options = {}) => operationsToDocumentInst.convert(operations, options),
};
